export default {"src":"https://images-cdn.curipod.com/d-e7f2f9e5/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};